export type Application = 'STEP' | 'RFNET' | 'BILLING' | 'REPAIR_HANDHELD' | 'ETERMINAL' | 'EDISTEP' | 'KIOSK';

export const ApplicationValues: Application[] = ['STEP', 'RFNET', 'BILLING', 'REPAIR_HANDHELD', 'ETERMINAL', 'EDISTEP', 'KIOSK'];
